import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './DeliveryType.css';


class DeliveryType extends Component {

    handleOptionChange = (event) => {
        if (this.props.deliveryType !== event.target.value)
        {
            this.props.onDataChanged('deliveryType',event.target.value);
            this.props.onDataChanged('deliveryType_valid',true);
        }
      }

    render () {
        let disable = false;
        if (this.props.userType !== 'admin') {
            if (!this.props.isInArea) {
                disable = true;
            }
        }
        return (
            <div className={classes.DeliveryType}>
                <div className={classes.Inline}>
                    <label className={classes.Label}>
                        Delivery
                    </label>
                    <div className="radio">
      <label>
        <input type="radio" radioGroup='rdoDelType' value="delivery" disabled={disable} checked={this.props.deliveryType == 'delivery'}  onChange={this.handleOptionChange} />
        Delivery
      </label>
   
      <label>
        <input type="radio" radioGroup='rdoDelType' value="pickup" checked={this.props.deliveryType == 'pickup'}  onChange={this.handleOptionChange}/>
        Pickup
      </label>
    </div>
    
                </div>
            </div>
        );
    }
};


const mapStateToProps = state => {
    return {
        isInArea: state.orders.order.isInArea,
        deliveryType: state.orders.order.deliveryType,
        isAuthenticated: state.orders.token !== null,
        userType: state.orders.userType
    };
}


export default connect(mapStateToProps)( DeliveryType);


// WEBPACK FOOTER //
// ./src/components/Order/DeliveryType/DeliveryType.js